import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RotateCcw, Mail } from 'lucide-react';
import { Button, Text } from '../components/ui';
import { useOnboardingStore } from '../store/useOnboardingStore';
import { generateMailtoLink } from '../utils/emailTemplateHelper';

const ErrorPage = () => {
  const navigate = useNavigate();
  const { userEmail: email } = useOnboardingStore();

  const handleTryAgain = () => {
    navigate('/dashboard');
  };

  const handleContactSupport = () => {
    const mailtoLink = generateMailtoLink('general_error', email);
    window.location.href = mailtoLink;
  };

  return (
    <div className='min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center px-4'>
      <div className='max-w-2xl rounded card-gradient shadow-xl p-12 w-full text-center'>
        <div className='mb-8'>
          <Text variant='heading' className='mb-4 text-[32px] md:text-inherit'>
            Something went wrong
          </Text>
          <Text variant='subtitle' className='mt-4'>
            We apologize for the inconvenience. Please try refreshing the page or contact our
            support team if the problem persists.
          </Text>
        </div>

        <div className='flex flex-col sm:flex-row gap-4 justify-center mt-8'>
          <Button
            variant='primary'
            size='md'
            icon={RotateCcw}
            onClick={handleTryAgain}
            className='w-full sm:w-auto'
          >
            Try again
          </Button>

          <Button
            variant='secondary'
            size='md'
            icon={Mail}
            onClick={handleContactSupport}
            className='w-full sm:w-auto'
          >
            Contact support
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
